import { InputType } from 'config'

import { EVENT_OPTIONS, PLATFORM_OPTIONS } from './type'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    name: {
      inputType: 'text',
      title: 'Name',
      required: true,
    },
    platform: {
      inputType: 'select',
      title: 'Platform',
      options: PLATFORM_OPTIONS,
      hasDefaultOption: false,
      required: true,
    },
    webhookUrl: {
      inputType: 'text',
      title: 'Incoming Webhook URL',
      required: true,
    },
    events: {
      inputType: 'multiselect',
      title: 'Notify on',
      options: EVENT_OPTIONS,
      value: {},
      required: true,
      defaultSelected: false,
    },
    enabled: {
      inputType: 'togglebutton',
      title: 'Enabled',
    },
  }
}
